<template>
  <svg
    @click="$emit('click')"
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    version="1.1"
    :class="classes"
    :style="styles"
  >
    <path
      d="M 12.117188,0.48632812 A 11.541421,11.541421 0 0 0 0.57617188,12.027344 11.541421,11.541421 0 0 0 12.117188,23.568359 11.541421,11.541421 0 0 0 23.658203,12.027344 11.541421,11.541421 0 0 0 12.117188,0.48632812 Z M 10,6 16,12 10,18 8.5898438,16.589844 13.169922,12 8.5898438,7.4101562 10,6 Z"
    />
  </svg>
</template>

<script>
import BaseIcon from '@/components/icons/BaseIcon'

export default {
  extends: BaseIcon,
  computed: {
    activeRotation () {
      return 180
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';
@import '_baseIcon';

svg {
  &.active {
    path {
      fill: $color-success !important;
    }
  }
}
</style>
